/**
 * Short messages shown at the bottom of the screen ("Link removed. Press Ctrl+Z to undo.").
 *
 * Any part of the GUI can call {@link toast}; the shell renders {@link toasts}.
 */
import { createSignal } from "solid-js";

/** How serious a toast is. Errors stay longer and are coloured. */
export type ToastKind = "info" | "error";

/** One message on screen. */
export interface Toast {
  /** Unique id, used as the list key. */
  id: number;
  /** The text. */
  text: string;
  /** Info or error. */
  kind: ToastKind;
}

const [list, setList] = createSignal<Toast[]>([]);
/** The id the next toast gets. */
let nextId = 1;

/** The messages currently shown, oldest first (at most three). */
export const toasts = list;

/** Shows `text` for a few seconds. */
export function toast(text: string, kind: ToastKind = "info"): void {
  const id = nextId++;
  setList((current) => [...current.slice(-2), { id, text, kind }]);
  setTimeout(() => setList((current) => current.filter((t) => t.id !== id)), kind === "error" ? 6000 : 3200);
}
